import { useFormAddProductsToCart } from '@graphcommerce/magento-product'
import { useEventCallback } from '@mui/material'
import { useEffect } from 'react'

declare global {
  interface Window {
    addProductToCart: (sku: string) => Promise<void | null>
  }
}

export function GlobalProductCartAction() {
  const form = useFormAddProductsToCart()
  const { handleSubmit, setValue } = form
  const submit = handleSubmit(() => {})

  const addProductToCart = useEventCallback(async (sku: string) => {
    setValue('cartItems.0.sku', sku)
    return submit()
  })
  useEffect(() => {
    if (typeof window.addProductToCart === 'undefined' && addProductToCart) {
      // Declare addProductToCart on the window object if it doesn't exist
      // usage: window.addProductToCart('sku') to add a product to the cart
      window.addProductToCart = addProductToCart
    }
  }, [addProductToCart])

  return null
}
